export class StickySettingsMutationTypes {
  public static readonly ResetStickyState = 'RESET_STICKY_STATE';
  public static readonly SetStickyStateField = 'SET_STICKY_STATE_FIELD';
}
